export const FeatureFlagDeclarations = {
  newTermsAndAgreements: {
    key: 'new-country-terms-and-conditions',
    defaultValue: {
      enabled: false,
      mustAcceptByDateUTC: '2021-04-26T00:00:00.000Z',
      newTermsLabel: 'canada_mar_2021',
    },
  },
  enableAddOnCentral: {
    key: 'enable-add-on-central',
    defaultValue: false,
  },
  enableSelfMigration: {
    key: 'enable-self-migration',
    defaultValue: false,
  },
  enableTransferOrders: {
    key: 'enable-stock-transfer',
    defaultValue: false,
  },
  enableCheapestRate: {
    key: 'enable-cheapest-rate',
    defaultValue: false,
  },
  enableDeliveryOptionsDetails: {
    key: 'enable-delivery-options-details',
    defaultValue: false,
  },
  enableApiSettingsRestrictions: {
    key: 'enable-api-settings-restrictions',
    default: false,
  },
  enableDeliveryOptionsForSellerLocation: {
    key: 'enable-delivery-options-for-seller-location',
    defaultValue: false,
  },
  enableManualStoreDeliveryOptions: {
    key: 'enable-manual-store-delivery-options',
    defaultValue: false,
  },
  enableNewFulfillmentPlanActivity: {
    key: 'enable-new-fulfillment-plan-activity',
    defaultValue: false,
  },
  enableDhlRecommendations: {
    key: 'enable-dhl-recommendations',
    defaultValue: false,
  },
  enableBrandedSMS: {
    key: 'enable-branded-sms',
    defaultValue: false,
  },
  enableThirdPartyDelivery: {
    key: 'enable-third-party-delivery',
    defaultValue: false,
  },
  enableV3CustomsWeightField: {
    key: 'enable-v3-customs-weight-and-sku-field',
    defaultValue: false,
  },
  enableExternalInventory: {
    key: 'enable-external-inventory',
    defaultValue: false,
  },
  // Per-country DDP feature flags
  enablePrepaidDutiesAndTaxUs: {
    key: 'enable-prepaid-duties-and-tax-us',
    defaultValue: false,
  },
  enablePrepaidDutiesAndTaxCa: {
    key: 'enable-prepaid-duties-and-tax-ca',
    defaultValue: false,
  },
  enableRateShopperFreemium: {
    key: 'enable-rate-shopper-freemium',
    defaultValue: false,
  },
  maximumServiceCollectionCount: {
    key: 'maximum-service-collection-count',
    defaultValue: 99,
  },
  enableAmazonShipNotifyUpdates: {
    key: 'enable-amazon-ship-notify-updates',
    defaultValue: false,
  },
  enableLocalDeliveryDriverTip: {
    key: 'enable-local-delivery-driver-tip',
    defaultValue: false,
  },
  enableBalanceHistory: {
    key: 'enable-balance-history',
    defaultValue: false,
  },
  enableBundledProducts: {
    key: 'enable-bundled-products',
    defaultValue: false,
  },
  enableV3AsyncLabelPrinting: {
    key: 'enable-v3-async-label-printing',
    defaultValue: false,
  },
  primaryPusherApp: {
    key: 'primary-pusher-app',
    defaultValue: window.SS_GLOBALS.frontEndConfig.pusherKey,
  },
  enableInteractiveReloadButtonOnOrdersGrid: {
    key: 'enable-interactive-reload-button-on-orders-grid',
    defaultValue: false,
  },
  enableCswRatePayloadDiff: {
    key: 'enable-csw-rate-payload-diff',
    defaultValue: false,
  },
  enableDelegationDate: {
    key: 'enable-delegation-date',
    defaultValue: false,
  },
  overwriteCustomerOverviewDebounce: {
    key: 'overwrite-customer-summary-debounce',
    defaultValue: 250,
  },
  enablePudoDeliveryOptions: {
    key: 'enable-pudo-delivery-options',
    defaultValue: false,
  },
  enableV3Coachmarks: {
    key: 'enable-v3-coachmarks',
    defaultValue: false,
  },
  newInsuranceSettingsEnabled: {
    key: 'new-insurance-settings-enabled',
    defaultValue: false,
  },
  enableConsolidatedBundleData: {
    key: 'enable-bundle-instock-data',
  },
  enableOrderBrandFilter: {
    key: 'enable-order-brand-filter',
    defaultValue: false,
  },
  enableV3ContainerLabelShipments: {
    key: 'enable-container-label-shipments',
    defaultValue: false,
  },
  enableOnboardVariantStoreSetup: {
    key: 'enable-onboard-variant-store-setup',
    defaultValue: false,
  },
  enableExtendedFulfillmentsGridSortFilter: {
    key: 'enable-extended-fulfillments-grid-sort-filter',
    defaultValue: false,
  },
  enableShippingSuppliesLink: {
    key: 'enable-shipping-supplies-link',
    defaultValue: false,
  },
  enableOrderOverview: {
    key: 'enable-order-overview',
    defaultValue: false,
  },
  enableWalletRegistrationErrorNotification: {
    key: 'enable-wallet-registration-error-notification',
    defaultValue: false,
  },
  enablePortionedEODManifest: {
    key: 'enable-portioned-eod-manifest',
    defaultValue: false,
  },
  enableSideBySideRateBrowser: {
    key: 'enable-side-by-side-rate-browser',
    defaultValue: false,
  },
  enableLiveRatesWithDimensions: {
    key: 'enable-live-rates-with-dimensions',
    defaultValue: false,
  },
  rateBrowserDefaultView: {
    key: 'rate-browser-default-view',
    defaultValue: 'carriers',
  },
  enableFulfillmentRates: {
    key: 'enable-fulfillment-rates',
    defaultValue: false,
  },
  enableRateBrowserFixup: {
    key: 'enable-rate-browser-fixup',
    defaultValue: false,
  },
  enableCreateLabelBatchesNavRefreshBypass: {
    key: 'enable-create-label-batches-nav-refresh-bypass',
    defaultValue: false,
  },
  enableMarketplaceSecondaryActionRework: {
    key: 'enable-marketplace-secondary-action-rework',
    defaultValue: false,
  },
  enableNewProductImport: {
    key: 'enable-new-product-import',
    defaultValue: false,
  },
  enableAddressValidator: {
    key: 'enable-address-validator',
    defaultValue: true,
  },
  enableAsyncReportGeneration: {
    key: 'enable-async-report-generation',
    defaultValue: false,
  },
  connectClientVersion: {
    key: 'connect-client-version',
  },
  enableSuncoAuthorization: {
    key: 'enable-sunco-authorization',
    defaultValue: false,
  },
  enableSetupFlow: {
    key: 'enable-setup-flow',
  },
  enableDeliveryOptionsCanadianShopify: {
    key: 'enable-delivery-options-ca-shopify',
    defaultValue: false,
  },
  enableDeliveryOptionsCanadianBigCommerce: {
    key: 'enable-delivery-options-ca-bigcommerce',
    defaultValue: false,
  },
  enableGrow493Experiment: {
    key: 'grow-493-orders-grid-empty-state-routing-change',
    defaultValue: 'go-to-onboarding',
  },
  enableSenderEmails: {
    key: 'enable-sender-emails',
    defaultValue: false,
  },
  enableAddOnCarousel: {
    key: 'enable-add-on-carousel',
    defaultValue: false,
  },
  enableHomePage: {
    key: 'enable-home-page',
    defaultValue: false,
  },
  enableHomePage2: {
    key: 'enable-home-page2',
    defaultValue: false,
  },
  gettingStartedGuideEnabled: {
    key: 'getting-started-guide',
    defaultValue: false,
  },
  enableDeliverByDate: {
    key: 'enable-deliver-by-date',
    defaultValue: false,
  },
  enablePremiumProgramTags: {
    key: 'enable-premium-program-tags',
    defaultValue: false,
  },
  enableCommittedInventoryCount: {
    key: 'enable-committed-inventory-count',
    defaultValue: false,
  },
  enableSyncInventoryOnOrderImport: {
    key: 'sync-inventory-on-order-import',
    defaultValue: false,
  },
  enableInventorySyncPercentage: {
    key: 'enable-inventory-sync-stock-percentage-option',
    defaultValue: false,
  },
  enableShopPromiseTag: {
    key: 'enable-shop-promise-tag',
    defaultValue: false,
  },
  enableReship: {
    key: 'enable-reship',
    defaultValue: false,
  },
  enableAddShipmentItems: {
    key: 'enable-add-shipment-items',
    defaultValue: false,
  },
  enableNewOrderImport: {
    key: 'enable-new-order-import',
    defaultValue: false,
  },
  enableFedexRateComparison: {
    key: 'enable-fedex-rate-comparison',
  },
  enableFedexWalletServiceMappings: {
    key: 'enable-fedex-wallet-service-mappings',
    defaultValue: false,
  },
  enableUspsRateComparison: {
    key: 'enable-usps-rate-comparison',
    defaultValue: false,
  },
  enableAsyncMarketplaceNotifications: {
    key: 'enable-async-marketplace-notifications',
    defaultValue: false,
  },
  enableAsyncSendNotifications: {
    key: 'enable-async-send-notifications',
    defaultValue: false,
  },
  enablePrinterFiltering: {
    key: 'enable-printer-filtering',
    defaultValue: false,
  },
  enableDangerousGoods: {
    key: 'enable-dangerous-goods',
    defaultValue: false,
  },
  enableLotTracking: {
    key: 'enable-lot-tracking',
    defaultValue: false,
  },
  enablePurchaseOrders: {
    key: 'enable-purchase-orders',
    defaultValue: false,
  },
  enableCompareRateOnLoad: {
    key: 'enable-compare-rate-on-load',
    defaultValue: {
      compareRate: false,
      debounceMs: 0,
    },
  },
  enableCompareUpsByoaToDap: {
    key: 'enable-compare-ups-byoa-to-dap',
    defaultValue: false,
  },
  enableGettingStartedGuideForExperiment: {
    key: 'enable-getting-started-guide-for-experiment',
    defaultValue: false,
  },
  enableGlobalPostRateComparison: {
    key: 'enable-globalpost-rate-comparison',
    defaultValue: false,
  },
  enableParcelGuardRateComparison: {
    key: 'enable-parcelguard-rate-comparison',
    defaultValue: false,
  },
  cutOffDateForHidingNonWalletInsurance: {
    key: 'cut-off-date-for-hiding-non-wallet-insurance',
    defaultValue: '',
  },
  enableAlternativeRatesShippingServiceRecommendations: {
    key: 'enable-alternative-rates-shipping-service-recommendations',
    defaultValue: false,
  },
  enableAlternativeRatesInsuranceRecommendations: {
    key: 'enable-alternative-rates-insurance-recommendations',
    defaultValue: false,
  },
  enableAlternativeRatesRateShopperRecommendations: {
    key: 'enable-alternative-rates-rate-shopper-recommendations',
    defaultValue: false,
  },
  enableAlternativeRatesInOrderGrid: {
    key: 'enable-alternative-rates-in-order-grid',
    defaultValue: false,
  },
  enhanceGlobalEShippingConfiguration: {
    key: 'enhance-global-e-shipping-configuration',
    defaultValue: false,
  },
  cutOffDateForSimplifiedPlanExperience: {
    key: 'cut-off-date-for-simplified-plan-experience',
    defaultValue: '',
  },
  shouldSendV3QueueServiceDownloadUrl: {
    key: 'should-send-v3-queue-service-download-url',
    defaultValue: false,
  },
  enableLegacyAlternativeRatesFallback: {
    key: 'enable-legacy-alternative-rates-fallback',
    defaultValue: false,
  },
  enableByoAbTesting: {
    key: 'enable-byo-ab-test',
    defaultValue: false,
  },
  enableRateShopperDeliverByDate: {
    key: 'enable-rate-shopper-deliver-by-date',
  },
  enableBulkRecommendedRatesOnSuperSelect: {
    key: 'enable-bulk-recommended-rates-on-super-select',
    defaultValue: false,
  },
  enableBulkRatesOnSuperSelect: {
    key: 'enable-bulk-rates-on-super-select',
    defaultValue: false,
  },
  enableBulkRefreshRatesOnSuperSelect: {
    key: 'enable-bulk-refresh-rates-on-super-select',
    defaultValue: false,
  },
  hideStampsConnection: {
    key: 'hide-stamps-connection',
    defaultValue: true,
  },
  enableAdyenSubscriptionPaymentMethod: {
    key: 'enable-adyen-for-subscription-payment-method',
    defaultValue: false,
  },
  enableScanInitialWeightRead: {
    key: 'enable-scan-initial-weight-read',
    defaultValue: false,
  },
  enableSecurityPage: {
    key: 'enable-security-page',
    defaultValue: false,
  },
  enableSmartfillABTest: {
    key: 'smartfill-ab-test',
    defaultValue: false,
  },
  enableAmazonBuyShippingAlternativeRates: {
    key: 'enable-amazon-buy-shipping-alternative-rates',
    defaultValue: false,
  },
  enableCostReviewModalRefactor: {
    key: 'enable-cost-review-modal-refactor',
    defaultValue: false,
  },
  enableCarrierInsuranceBanner: {
    key: 'enable-carrier-insurance-banner',
    defaultValue: false,
  },
  disableAutomationRuleInsureCarrier: {
    key: 'disable-automation-rule-insure-carrier',
    defaultValue: false,
  },
  enableNewLayoutOptions: {
    key: 'enable-new-layout-options',
    defaultValue: false,
  },
  enableMultiPackageShipmentsOrderDetails: {
    key: 'multi-package-shipments-order-details',
    defaultValue: false,
  },
  enableMultiPackageShipments: {
    key: 'multi-package-shipments',
    defaultValue: false,
  },
  enablePickPackAccess: {
    key: 'enable-pick-pack-access',
    defaultValue: false,
  },
  enableShipFromSearchableDropdown: {
    key: 'enable-ship-from-searchable-dropdown',
    defaultValue: false,
  },
  enableAuctanePayIdv: {
    key: 'enable-plaid-idv',
    defaultValue: false,
  },
  enable2025Q2PlanFeatureGates: {
    key: 'enable-2025-q2-plan-feature-gates',
    defaultValue: false,
  },
  enableShippingServiceSearchableDropdown: {
    key: 'enable-shipping-service-searchable-dropdown',
    defaultValue: false,
  },
  enableScanToReceive: {
    key: 'enable-scan-to-receive',
    defaultValue: false,
  },
  enableAutomationRecommendations: {
    key: 'enable-automation-recommendations',
    defaultValue: false,
  },
  enableReorderAssist: {
    key: 'enable-reorder-assist',
    defaultValue: false,
  },
  enableLotTrackingBillingPlan: {
    key: 'enable-lot-tracking-billing-plan',
    defaultValue: false,
  },
  enablePickPackSettings: {
    key: 'enable-pick-and-pack-settings',
    defaultValue: false,
  },
  enablePickToTote: {
    key: 'enable-pick-to-tote',
    defaultValue: false,
  },
  enableSurchargeUI: {
    key: 'enable-surcharge-ui',
    defaultValue: false,
  },
  enableBillingReport: {
    key: 'enable-billing-report',
    defaultValue: false,
  },
  enableDutiesInAmountSummary: {
    key: 'enable-duties-in-amount-summary',
    defaultValue: false,
  },
  enableLabsSettingsPage: {
    key: 'enable-labs-settings-page',
    defaultValue: false,
  },
  enableInventoryLocationsBarcode: {
    key: 'enable-inventory-locations-barcode',
    defaultValue: false,
  },
  enableSsrActivationNoAuth: {
    key: 'enable-ssr-activation-no-auth',
    defaultValue: false,
  },
  enableInventoryLocationCsvImport: {
    key: 'enable-inventory-location-csv-import',
    defaultValue: false,
  },
  enableWalletedFedexNotification: {
    key: 'enable-walleted-fedex-notification',
    defaultValue: false,
  },
  enableAddToPickingQueue: {
    key: 'enable-add-to-picking-queue',
    defaultValue: false,
  },
  enablePickingExceptions: {
    key: 'enable-picking-exceptions',
    defaultValue: false,
  },
  isRefundAssistVisible: {
    key: 'refund-assist-is-visible',
    defaultValue: false,
  },
  enableSendPurchaseOrderEmails: {
    key: 'enable-send-purchase-order-emails',
    defaultValue: false,
  },
  enableShopifyProductAndInventorySync: {
    key: 'enable-shopify-product-and-inventory-sync',
    defaultValue: false,
  },
  enableUspsCopNsaInstruction: {
    key: 'enable-usps-cop-nsa-instruction', // this is the feature flag that allows the sellerId to be used instead of the couponCode
    defaultValue: false,
  },
  enableUspsCopAccountSetup: {
    key: 'enable-usps-cop-account-setup', // this is the global feature flag on/off switch
    defaultValue: false,
  },
  enablePickPackSettingsMobileConfiguration: {
    key: 'enable-pick-pack-settings-mobile-configuration',
    defaultValue: false,
  },
  enableWalletTermsModal: {
    key: 'enable-wallet-terms-modal',
    defaultValue: false,
  },
  enableFulfillmentsReturns: {
    key: 'enable-fulfillments-returns',
    defaultValue: false,
  },
  enableEnhancedReturnsErrors: {
    key: 'enable-enhanced-returns-errors',
    defaultValue: false,
  },
  enableSierraChat: {
    key: 'enable-sierra-chat',
    defaultValue: false,
  },
  enableHsCodesFetchingForAll: {
    key: 'enable-hs-codes-fetching-for-all',
    defaultValue: false,
  },
  enableDynamicPricing: {
    key: 'enable-dynamic-pricing',
    defaultValue: false,
  },
  enableBatchScanning: {
    key: 'enable-batch-scanning',
    defaultValue: false,
  },
  enableAsyncSyncProductsAndSubmitAsn: {
    key: 'enable-async-sync-products-and-submit-asn',
    defaultValue: false,
  },
  enableCreateOrderFromAsn: {
    key: 'enable-create-order-from-asn',
    defaultValue: false,
  },
  enableAIAutomationRule: {
    key: 'enable-generate-automation-rule-with-ai',
    defaultValue: false,
  },
  enableLossPrevention: {
    key: 'enable-loss-prevention',
    defaultValue: false,
  },
  enableShipStationAnalyticsOverride: {
    key: 'enable-shipstation-analytics-overrride',
    defaultValue: false,
  },
  enableAiShippyAssistant: {
    key: 'enable-ai-shippy-assistant',
    defaultValue: false,
  },
  enableShippySierraChatIntegration: {
    key: 'enable-shippy-sierra-chat-integration',
    defaultValue: false,
  },
  switchFulfillmentDashboardToRawEndpoint: {
    key: 'switch-fulfillment-dashboard-to-raw-endpoint',
    defaultValue: false,
  },
  enableAiHarmonizationCodeGenerator: {
    key: 'enable-ai-harmonization-code-generator',
    defaultValue: false,
  },
  enableFbsZoneComparisonSection: {
    key: 'enable-fbs-zone-comparison-section',
    defaultValue: false,
  },
  enableSellerPhoneUpdate: {
    key: 'enable-seller-phone-update',
    defaultValue: false,
  },
  enableScanToVerifyInOrderDetails: {
    key: 'enable-scan-to-verify-in-order-details',
    defaultValue: false,
  },
  enableProductItemWeightAndDimensions: {
    key: 'enable-product-item-weight-and-dimensions',
    defaultValue: false,
  },
  enableShippingServiceSearchableDropdownInRateBrowser: {
    key: 'enable-shipping-service-searchable-dropdown-in-rate-browser',
    defaultValue: false,
  },
  enableShippingServiceSearchableDropdownInSidebar: {
    key: 'enable-shipping-service-searchable-dropdown-in-sidebar',
    defaultValue: false,
  },
  enable24HourShopifyProductSync: {
    key: 'enable-24-hour-shopify-product-sync',
    defaultValue: false,
  },
  enableShippingOptionsForRateShoppers: {
    key: 'enable-shipping-options-for-rate-shoppers',
    defaultValue: false,
  },
  enableShippingOptionsForDefaultRateShoppers: {
    key: 'enable-shipping-options-for-default-rate-shoppers',
    defaultValue: false,
  },
  enableSingleLabelSellerExperiment: {
    key: 'enable-single-label-seller-experiment',
    defaultValue: false,
  },
  enableCm6PackingSlipEditor: {
    key: 'enable-cm6-packing-slip-editor',
    defaultValue: false,
  },
  enableNewHtmlEditorForPackingSlips: {
    key: 'enable-new-html-editor-for-packing-slips',
    defaultValue: false,
  },
  enablePurchaseOrderCsvImport: {
    key: 'enable-purchase-order-csv-import',
    defaultValue: false,
  },
  enableSingleFulfillmentPlanOrdersGridSidebarDrawerRedesign: {
    key: 'enable-single-fulfillment-plan-orders-sidebar-redesign',
    defaultValue: false,
  },
  enableUpsLabelTermsV2: {
    key: 'enable-ups-label-terms-v2',
    defaultValue: false,
  },
  enableSuppliersGrid: {
    key: 'enable-suppliers-grid',
    defaultValue: false,
  },
  enableSupplyPage: {
    key: 'enable-supply-page',
    defaultValue: false,
  },
  enableSaveShippingConfigServiceCollectionSync: {
    key: 'enable-save-shipping-config-service-collection-sync',
    defaultValue: false,
  },
  enableBackgroundImport: {
    key: 'enable-background-import',
    defaultValue: false,
  },
  enableProductDetailsDrawerV3: {
    key: 'enable-product-details-drawer-v3',
    defaultValue: false,
  },
  enableInsurancePromoExperiment: {
    key: 'enable-insurance-promo',
    defaultValue: false,
  },
  enableInsurancePromoExtended: {
    key: 'enable-insurance-promo-extended',
    defaultValue: false,
  },
  enableNotificationHub: {
    key: 'enable-notification-hub',
    defaultValue: false,
  },
  enableCustomPackageWeights: {
    key: 'enable-custom-package-weights',
    defaultValue: false,
  },
  enablePlanFeaturesTrialUpsell: {
    key: 'enable-plan-features-trial-upsell',
    defaultValue: false,
  },
  enableUpgradePlanPromotionalBanner: {
    key: 'enable-upgrade-plan-promotional-banner',
  },
  enableAnalyticsRoleSelfService: {
    key: 'enable-analytics-role-self-service',
    defaultValue: false,
  },
};
